<template>
  <v-container class="px-5 px-md-18 py-14 py-md-8">
    <v-card-title
      class="display-1 font-weight-bold pa-0 mb-8 letter-spacing-normal"
    >
      Checkout
      <v-progress-linear v-if="groupModel.fetching" indeterminate />
    </v-card-title>
    <v-row
      v-if="!group.sightings_reported"
      class="justify-lg-space-between align-center"
    >
      No sightings reported!
    </v-row>
    <v-card-text v-else class="pa-0">
      <v-row
        v-for="(summary, index) in report"
        :key="index"
        class="justify-lg-space-between align-center"
      >
        <v-col sm="12">
          <v-row class="justify-lg-space-between align-center">
            <v-col class="pa-0">
              <v-card-title
                class="py-0 mb-12 mb-mb-0 title font-weight-bold letter-spacing-normal"
              >
                {{ getSummaryTitle(summary.member) }}
              </v-card-title>
            </v-col>
          </v-row>
          <v-row class="justify-lg-space-between align-center">
            <v-col class="pa-0">
              <v-skeleton-loader
                v-if="!groupModel.fetched || groupModel.fetching"
                height="180"
                type="table-thead, table-tbody, table-tfoot"
                class="mb-12"
              />
              <v-data-table
                v-else
                :headers="headers"
                :items="summary.sightings"
                v-bind="
                  summary.sightings.length > 5
                    ? { itemsPerPage: 5 }
                    : { hideDefaultFooter: true }
                "
                class="primary-table with-shadow border-radius-0 v-data-table-1 v-data-table-1--style3"
              >
                <template v-slot:item.price_per_sighting="{ value }">
                  {{ value.currency(2) }}
                </template>
                <template v-slot:item.amount="{ value }">
                  {{ value.currency(2) }}
                </template>
                <template v-slot:body.append>
                  <tr class="table-footer">
                    <td colspan="3" />
                    <td>
                      ${{
                        summary.sightings.reduce(
                          (total, data) => total + data.amount.currency(),
                          0
                        )
                      }}
                    </td>
                  </tr>
                </template>
              </v-data-table>
            </v-col>
          </v-row>
        </v-col>
      </v-row>
      <Contribution
        v-if="details"
        :total="details.amount || 0"
        :days="days"
        :members="group.members.length"
      />

      <v-row class="justify-lg-space-between align-center">
        <v-col class="pa-0">
          <v-card-title
            class="py-0 title font-weight-bold letter-spacing-normal"
          >
            Select a Project make your donation.
          </v-card-title>
        </v-col>
      </v-row>
      <ProjectSelector
        class="mt-4"
        v-model="project_id"
        :operator-id="
          !!currentUser.isTourist() ? group.tourism_operator_id || 0 : 0
        "
      />
      <!--      <ProjectSlider class="mt-4" :group="group" v-model="project_id" />-->
    </v-card-text>
  </v-container>
</template>

<script>
import Group from '@models/Group';
import ProjectSelector from '@components/ProjectSelector';

export default {
  name: 'CheckoutDetails',
  components: {
    ProjectSelector,
    Contribution: () => import('./Contribution'),
    // ProjectSlider: () => import('./ProjectSlider'),
  },
  props: {
    group: {
      type: Object,
      required: true,
    },
    details: {
      type: Object,
      required: true,
    },
    groupModel: {
      type: Group,
      required: true,
    },
    value: {
      type: [Number, String, Boolean],
      default: 0,
    },
  },
  data() {
    return {
      headers: [
        {
          text: 'Species',
          align: 'left',
          sortable: false,
          value: 'species.name',
        },
        { text: 'Count', value: 'count' },
        { text: 'Price', value: 'price_per_sighting' },
        { text: 'Total', value: 'amount' },
      ],
      project_id: this.value,
      requiresUpdate: true,
    };
  },
  computed: {
    report() {
      let self = this;
      let report = [];
      self.group.members.forEach((member, index) => {
        report.push({
          member,
          sightings:
            self.details && self.details.sightings
              ? self.details.sightings
                  .filter((attendee) => attendee.member_id === member.id)
                  .map((attendee) => {
                    return {
                      species_id: attendee.species_id,
                      species: attendee.species,
                      price_per_sighting: attendee.price_per_sighting,
                      count: attendee.count,
                      amount: attendee.amount,
                    };
                  })
              : [],
        });
      });
      return report;
    },
    days() {
      return $moment(this.group.check_out).diff(this.group.check_in, 'days');
    },
  },
  watch: {
    async project_id(projectID) {
      this.requiresUpdate = false;
      this.$emit('input', projectID);
    },
    value() {
      if (!this.requiresUpdate) {
        this.requiresUpdate = true;
        return;
      }
      this.project_id = this.value;
    },
  },
  methods: {
    getSummaryTitle(member) {
      let name = member.first_name;
      if (name.endsWith('s')) {
        return `${name}' Sightings`;
      }
      return `${name}'s Sightings`;
    },
  },
};
</script>

<style lang="scss">
.large-thumb .v-slider__thumb-label {
  width: 42px;
  height: 42px;
}
</style>
